export enum tipoRiga {
  TESTO = 'testo',
  ICONA = 'icona'
};

